<template>
    <div class="fotter-container">
        <div class="about-us">
            <ul>
                <li v-for="(item, i) in navList" :key="i" :class="{licenter:i==1|i==4,lileft:i==0||i==3}">
                    <span class="gang-l" v-show="i==1||i==4">|</span>
                    <span class="name" @click="toPage(item.path)">{{item.name}}</span>
                    <span class="gang-r" v-show="i==1||i==4">|</span>
                </li>
            </ul>
        </div>
        <div class="code-img">
            <div class="img-item-box" @click="toWeb(1)">
                <div class="img-box">
                    <img src="https://cdn1.p2ipo.com/common/wanchao-logo2x.png" alt="">
                </div>
                <p class="name">湾潮</p>
            </div>
            <div class="img-item-box" @click="toWeb(2)">
                <div class="img-box">
                    <img src="https://cdn1.p2ipo.com/common/cangqiong-logo2x.png" alt="">
                </div>
                <p class="name">苍穹系统</p>
            </div>
            <div class="img-item-box" @click="toWeb(3)">
                <div class="img-box">
                    <img src="https://cdn1.p2ipo.com/common/yuncang-logo2x.png" alt="">
                </div>
                <p class="name">山海云仓</p>
            </div>
        </div>
        <div class="txt1">
            版权所有@交大众创&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;技术支持@网银软件
        </div>
        <div class="txt2" @click="toWeb(4)">粤ICP备19079019号</div>
    </div>
</template>
<script>
export default {
    name: 'footersM',
    data() {
        return {
            navList: [
                {
                    name: '街道',
                    path: '/streetM',
                    page: 'streetM'
                },
                {
                    name: '院校',
                    path: '/academyM',
                    page: 'academyM'
                },
                {
                    name: '投资者',
                    path: '/investmentM',
                    page: 'investmentM'
                },
                {
                    name: '交易所',
                    path: '/exchangeM',
                    page: 'exchangeM'
                },
                {
                    name: '协会',
                    path: '/associationM',
                    page: 'AssociationM'
                },
                {
                    name: '关于我们',
                    path: '/aboutUsM',
                    page: 'aboutUsM'
                }
            ]
        }
    },
    methods: {
        toPage(path) {
            let menuActive = {
                menuStatus: -1
            };
            window.sessionStorage.setItem("menuActive", JSON.stringify(menuActive));
            this.$router.push({path: path});
        },
        toWeb(i) {
            let href = '';
            switch (i) {
                case 1: // 湾潮
                    href = 'https://www.bigbays.cn';
                    break;
                case 2: // 苍穹
                    href = 'http://www.mvcsky.com';
                    break;
                case 3: // 云仓
                    href = 'http://web.p2ipo.com';
                    break;
                case 4: // 备案
                    href = 'https://beian.miit.gov.cn';
                    break;
            }
            window.location.href = href;
        }
    }
}
</script>
<style lang="scss" scoped>
@import './FootersM.scss';
</style>


// WEBPACK FOOTER //
// src/components/mobile/common/footers/FootersM.vue